import { Field, fieldClass, Group } from "./BriefField";

export const BriefYou = ({ form, errors, set }) => (
  <Group id="01" title="You">
    <div className="grid gap-7 md:grid-cols-2">
      <Field label="Name" htmlFor="brief-name" error={errors.name} errorTestId="brief-error-name">
        <input
          id="brief-name"
          data-testid="brief-name-input"
          className={fieldClass}
          value={form.name}
          onChange={set("name")}
          placeholder="Your name"
          aria-invalid={!!errors.name}
        />
      </Field>
      <Field
        label="Email"
        htmlFor="brief-email"
        error={errors.email}
        errorTestId="brief-error-email"
      >
        <input
          id="brief-email"
          type="email"
          data-testid="brief-email-input"
          className={fieldClass}
          value={form.email}
          onChange={set("email")}
          placeholder="you@company.com"
          aria-invalid={!!errors.email}
        />
      </Field>
      <Field label="Company / Brand" hint="optional" htmlFor="brief-company">
        <input
          id="brief-company"
          data-testid="brief-company-input"
          className={fieldClass}
          value={form.company}
          onChange={set("company")}
          placeholder="Company or brand name"
        />
      </Field>
      <Field label="Website" hint="optional" htmlFor="brief-website">
        <input
          id="brief-website"
          data-testid="brief-website-input"
          className={fieldClass}
          value={form.website}
          onChange={set("website")}
          placeholder="https://"
        />
      </Field>
    </div>
  </Group>
);

export default BriefYou;
